import FloatingBottom from './FloatingBottom';
export default FloatingBottom;
